"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.makeRuleProductFactory = makeRuleProductFactory;
var _get2 = _interopRequireDefault(require("lodash/get"));
var _includes2 = _interopRequireDefault(require("lodash/includes"));
var _lowerCase2 = _interopRequireDefault(require("lodash/lowerCase"));
/**
 * make rule product factory
 * @param {Function} convertAndFormat convert and format price util
 * @returns {Function} ruleProductFactory
 */
function makeRuleProductFactory(convertAndFormat = x => x) {
  /**
   * rule product factory
   * @param {Object} rule plain unformatted rule product from cart's products
   * @returns {Object} formatted rule product
   */
  return function ruleProductFactory(rule) {
    const totalPrice = (0, _get2.default)(rule, 'price.total');
    const description = (0, _get2.default)(rule, 'description');
    const totalWithVat = (0, _get2.default)(rule, 'price.totalWithVat');
    return {
      description,
      totalPrice,
      totalWithVat,
      displayedTotalPrice: convertAndFormat(totalPrice),
      displayedTotalPriceWithVat: convertAndFormat(totalWithVat),
      displayedCurrency: (0, _get2.default)(rule, 'displayPrice.currency'),
      isServiceFee: (0, _includes2.default)((0, _lowerCase2.default)(description), 'service fee'),
      isDiscount: Math.sign(totalPrice) === -1,
      blockedRewards: (0, _get2.default)(rule, 'options.blockedRewards')
    };
  };
}